// extracted by mini-css-extract-plugin
export default {"tabs":"OrganisationsAccounts_tabs__iyb-U"};